export default __webpack_public_path__ + "static/media/scorekeeper.6fe3b9de.PNG";